import { HttpService } from '@Engage.Data.Services';
class QualifierRepositoryClass {
    constructor() { }
    getQualifierList() {
        return HttpService.get('paywall/qualifiers');
    }
    getPaywall(data) {
        return HttpService.post('paywall', data);
    }
}
export const QualifierRepository = new QualifierRepositoryClass();
